export const CIRCLE_STEPS = 64

export const IMPRESSIONS = 'impressions'

export const HEATMAP_BY_TYPES = {
  IMPRESSIONS: 'impressions',
  AUDIENCE: 'audience',
} as const
